import { render, staticRenderFns } from "./PhoneGroup.vue?vue&type=template&id=18304c75&scoped=true&"
import script from "./PhoneGroup.vue?vue&type=script&lang=js&"
export * from "./PhoneGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18304c75",
  null
  
)

export default component.exports